import React from 'react';

const COSAddSikkaCreds = () => {
    return (
        <div style={{ margin: '2rem', maxWidth: '40rem' }}>
            <h1>Sikka credentials</h1>
            <p>
                Sikka logins are stored in Dash and are no longer saved in
                Oracle.
            </p>
        </div>
    );
};

export default COSAddSikkaCreds;
